import React from "react";
import { Box, FormHelperText, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { FieldArray, useFormikContext, Field } from "formik";
//import { Delete as DeleteIcon, Add } from "@mui/icons-material";
import QuestionTextField from "./QuestionTextField";
import AnswersField from "./AnswersField";
import { PropTypes } from "prop-types";
import { TextField } from "formik-mui";

// Not needed for MVP
/* const getNewShortAnswer = order => ({
  order,
  text: "",
  id: uuid(),
  type: "answer"
}); */

const ShortAnswerTextField = ({ blankIndex, onDelete }) => {
  const { t } = useTranslation();

  // For MVP, we'll only allow one blank so we don't need to show the blank index
  /* const label = t("editQuestion.blankPlaceholder", {
    index: blankIndex + 1
  }); */

  return (
    <Box display="flex" data-qa="short-answer-text-field" mb={4.5}>
      <Field
        variant="filled"
        fullWidth
        label={t("editQuestion.blankPlaceholder")}
        component={TextField}
        name={`answers[${blankIndex}].text`}
      />
      {/* Delete button not needed for MVP */}
      {/* <Box display="flex" alignItems="center" ml={1}>
        <IconButton
          onClick={() => onDelete(blankIndex)}
          data-qa="ordering-text-delete-btn"
        >
          <DeleteIcon color="primary" />
        </IconButton>
      </Box> */}
    </Box>
  );
};

const ShortAnswerFields = ({
  isSurveyQuestion,
  questionFilesList,
  setQuestionFilesList
}) => {
  const { t } = useTranslation();
  const {
    errors,
    values: { answers },
    submitCount
  } = useFormikContext();

  // Deleting blanks not needed for MVP
  /* const handleDeleteBlank = deletedBlankIndex => {
    let newAnswers = [...answers];
    newAnswers.splice(deletedBlankIndex, 1);
    newAnswers = newAnswers.map((answer, order) => ({
      ...answer,
      order
    }));
    setFieldValue("answers", newAnswers);
  }; */

  return (
    <Box display="flex" flexDirection="column">
      <QuestionTextField
        questionFilesList={questionFilesList}
        setQuestionFilesList={setQuestionFilesList}
      />
      {!isSurveyQuestion && (
        <AnswersField
          renderAnswers={() => (
            <Box display="flex" flexDirection="column" flex={1}>
              {!isSurveyQuestion && (
                <Typography variant="subtitle1" sx={{ mt: 1, mb: 4.5 }}>
                  {t("editQuestion.shortAnswerQuestionQuizNote")}
                </Typography>
              )}
              <FieldArray
                name="answers"
                render={({ push }) => (
                  <Box
                    display="flex"
                    flexDirection="column"
                    flex={1}
                    maxWidth={{ xs: "unset", md: "60%" }}
                  >
                    {answers.map((shortAnswer, index) => (
                      <ShortAnswerTextField
                        key={shortAnswer.id}
                        blankIndex={index}
                        // onDelete={handleDeleteBlank}
                      />
                    ))}
                    {!!errors.answers && submitCount > 0 && (
                      <Box ml={1.75} mt={-0.5} mb={2}>
                        <FormHelperText error={true}>
                          {errors.answers}
                        </FormHelperText>
                      </Box>
                    )}
                    {/* Add Blank button not necessary for MVP */}
                    {/*
                    <Box mb={2} mt={1} ml={-1.5}>
                      <Button
                        color="primary"
                        startIcon={<Add />}
                        onClick={() => push(getNewShortAnswer(answers.length))}
                        data-qa="add-short-answer-btn"
                      >
                        {t("editQuestion.addBlankBtn")}
                      </Button>
                    </Box> */}
                  </Box>
                )}
              />
            </Box>
          )}
        />
      )}
    </Box>
  );
};

ShortAnswerFields.propTypes = {
  isSurveyQuestion: PropTypes.bool,
  questionFilesList: PropTypes.array,
  setQuestionFilesList: PropTypes.func
};

export default ShortAnswerFields;
